import React from "react";
import { Stream } from "@cloudflare/stream-react";
import { react2angular } from "react18-react2angular";

function useStreamCallback(callback, streamRef, playerId) {
    return React.useCallback(
        function () {
            if (typeof callback === "function") {
                callback({ player: streamRef.current, id: playerId });
            }
        },
        [callback, streamRef, playerId],
    );
}

function CfVideoReact(props) {
    const streamRef = React.useRef();
    const readySent = React.useRef(false);

    const triggerReady = React.useCallback(
        function () {
            if (
                !readySent.current &&
                typeof props.readyCallback === "function" &&
                streamRef.current
            ) {
                readySent.current = true;
                props.readyCallback({
                    player: streamRef.current,
                    id: props.playerId,
                });
            }
        },
        [props.playerId, props.readyCallback],
    );

    const handleEnded = useStreamCallback(
        props.endedCallback,
        streamRef,
        props.playerId,
    );
    const handlePause = useStreamCallback(
        props.pauseCallback,
        streamRef,
        props.playerId,
    );
    const handleTimeUpdate = useStreamCallback(
        props.timeUpdateCallback,
        streamRef,
        props.playerId,
    );
    const handleError = useStreamCallback(
        props.errorCallback,
        streamRef,
        props.playerId,
    );

    React.useEffect(
        function () {
            readySent.current = false;
        },
        [props.srcId],
    );

    if (!props.srcId) {
        return null;
    }

    return React.createElement(Stream, {
        src: props.srcId,
        streamRef: streamRef,
        className: "aspect-video relative max-h-video-container",
        controls: true,
        width: "100%",
        height: "100%",
        responsive: false,
        onCanPlay: triggerReady,
        onLoadedMetaData: triggerReady,
        onEnded: handleEnded,
        onPause: handlePause,
        onTimeUpdate: handleTimeUpdate,
        onError: handleError,
    });
}

const component = react2angular(CfVideoReact, [
    "srcId",
    "readyCallback",
    "endedCallback",
    "pauseCallback",
    "timeUpdateCallback",
    "errorCallback",
    "playerId",
]);

export default {
    ...component,
    name: "cfVideo",
};
